export default __webpack_public_path__ + "static/media/Menu_header_mobileview.31a0ed73.svg";